import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Color } from './color.model';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { HistoryProvider } from '../../core/browser-providers';
import { Http } from '@angular/http';
import { MediaService } from '../../shared-services/media.service';
import { NavigationService } from '../../shared-services/navigation.service';
import { DialogService } from '../../shared-components/modals/dialog.service';

@Component({
  selector: 'app-color-add-edit',
  templateUrl: './color-add-edit.component.html',
  styleUrls: ['./color-add-edit.component.scss']
})
export class ColorAddEditComponent implements OnInit {
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  @ViewChild('form') public roleForm: NgForm;

  validationFail = false;
  item: Color;

  messageTitle: string;

  isHD = false;
  colores = ['#000000', '#0000AA', '#00AA00', '#00AAAA', '#AA0000', '#AA00AA', '#AA5500', '#AAAAAA', '#555555', '#5555FF', '#55FF55', '#55FFFF','#FF5555', '#FF55FF', '#FFFF55', '#FFFFFF' ];
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    @Inject(HistoryProvider) private history: History,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
  ) { }

  ngOnInit() {
    this.route.data.subscribe(data => {
      this.item = data.user;
      this.item.description = this.item.id ? this.item.description : '';
    });

    this.messageTitle = this.item.id  ? 'Edición de color' : 'Alta de color';

    this.mediaService.isHighDefinition.subscribe(isHD => this.isHD = isHD);
  }
  back() {
    this.navigationService.back();
  }

  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }

    return;
  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar el color ' + this.item.description + '?')
    .then( res => {
      if (res) {
        this.saveItem(res);
      }
    });
  }

  async saveItem(res) {
    if (res) {

      this.snackService.spinner(true);

      if (this.item.id) { // Update
        try {
          await await this.backendService.update(Color.path + this.item.id, this.item);
          this.snackService.success('Color editado');
          this.router.navigate(['/colores']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      } else {
        try {
          await this.backendService.create(Color.path, this.item);
          this.snackService.success('Color creado');
          this.router.navigate(['/colores']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/productos/color/color-add-edit.component.ts